<template>
  <div>
    <h1 class="mt-4">{{ $t("contact.name") }}</h1>
    <Address
      class="mt-5 mb-5"
      :name="$t('contact.card1.name')"
      :address="$t('contact.card1.address')"
      :gg="$t('contact.card1.gg')"
    />
    <Address
      class="mt-5 mb-5"
      :name="$t('contact.card2.name')"
      :address="$t('contact.card2.address')"
      :gg="$t('contact.card2.gg')"
    />
    <br />
    <!-- <Form class="mt-5 mb-5" /> -->
  </div>
</template>

<script>
import Address from "@/components/contact/Address.vue";
export default {
  components: { Address },
};
</script>

<style scoped>
div {
  overflow: hidden;
}
img {
  width: 90%;
}
iframe {
  width: 90%;
}
@media screen and (max-width: 780px) {
  .map h3 {
    margin-left: 4%;
  }
}
</style>
